import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Users, Shield, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const pillars = [{
    icon: <Users className="w-6 h-6 text-purple-700" data-id="element-402" data-mp="3o9kbp3bdjp7h" />,
    title: 'Women Seeking Wellness',
    desc: 'Personalized, intelligent pathways tailored to individual needs.'
  }, {
    icon: <Shield className="w-6 h-6 text-purple-700" data-id="element-403" data-mp="142rjgle32zj" />,
    title: 'Verified Practitioners',
    desc: 'A trusted network of vetted, specialized care providers.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-purple-700" data-id="element-404" data-mp="aue6dy6m2wl7" />,
    title: 'Premium Brands',
    desc: 'Curated wellness products and services that align with your journey.'
  }];
  return <Section background="ivory" className="bg-purple-100" data-id="element-405" data-mp="5xnjaqwe30qa">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-406" data-mp="ktd4imtr39ty">
        <FadeIn data-id="element-407" data-mp="fu0lye9wwox6">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-408" data-mp="fua3rekszprs">
            A Curated Digital Wellness Marketplace
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-409" data-mp="36cp1wsnqvvj8">
            Fem Entity is a private, intelligent platform designed to unify the
            wellness experience for women.
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-410" data-mp="3kadl7w25yum6">
        {pillars.map((pillar, idx) => <FadeIn key={idx} delay={idx * 200} data-id="element-411" data-mp="3p9q64b9h5rm4" data-mpi={idx}>
            <div className="bg-white/80 backdrop-blur-sm border border-purple-200 p-8 rounded-2xl h-full transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-purple-200/30" data-id="element-412" data-mp="3p8ym7xp8pibo">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm" data-id="element-413" data-mp="2ufa67nqmf8d">
                {pillar.icon}
              </div>
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-414" data-mp="bv3lgulqy1hk">
                {pillar.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-415" data-mp="guq098h83psh">{pillar.desc}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={600} data-id="element-416" data-mp="2cuqfp4kmm61a">
        <div className="glass-panel rounded-3xl p-8 md:p-12 text-center max-w-4xl mx-auto" data-id="element-417" data-mp="27xzzmh8tnafv">
          <h3 className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-8" data-id="element-418" data-mp="2mmmeyiyg8273">
            Core Experience Layers
          </h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-419" data-mp="2hv4dltsijzll">
            <div className="flex-1" data-id="element-420" data-mp="2vlzpzg280ytx">
              <div className="text-xl font-serif text-charcoal mb-2" data-id="element-421" data-mp="2vp5fgweri2q6">
                Discover
              </div>
              <div className="text-sm text-charcoal/60" data-id="element-422" data-mp="35lgrdlafwqk3">
                Trusted practitioners & services
              </div>
            </div>
            <div className="hidden md:block w-8 h-[1px] bg-charcoal/20" data-id="element-423" data-mp="30np2z1907mkn"></div>
            <div className="flex-1" data-id="element-424" data-mp="1b6xtjw0ufb8e">
              <div className="text-xl font-serif text-charcoal mb-2" data-id="element-425" data-mp="1b7zc0lk6v005">
                Personalize
              </div>
              <div className="text-sm text-charcoal/60" data-id="element-426" data-mp="16ah6741gx0wd">
                AI-guided wellness plans
              </div>
            </div>
            <div className="hidden md:block w-8 h-[1px] bg-charcoal/20" data-id="element-427" data-mp="3mvcd8zvd8znm"></div>
            <div className="flex-1" data-id="element-428" data-mp="385wp7rn7z8bm">
              <div className="text-xl font-serif text-charcoal mb-2" data-id="element-429" data-mp="384vczjugwfsb">
                Engage
              </div>
              <div className="text-sm text-charcoal/60" data-id="element-430" data-mp="3d3oqhc9r86sh">
                Book, track, and optimize
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}